import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-cosmic-black border-t border-gold-primary border-opacity-20 py-12" data-id="element-466">
      <div className="container mx-auto px-6" data-id="element-467">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0" data-id="element-468">
          <div className="text-center md:text-left" data-id="element-469">
            <h3 className="text-2xl font-serif font-bold text-gold-light mb-2" data-id="element-470">
              LOS 12
            </h3>
            <p className="text-gray-400 text-sm" data-id="element-471">
              Doce entidades. Doce energías. Doce reinos.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm" data-id="element-472">
            <Link to="/terminos" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-473">
              Términos y condiciones
            </Link>
            <Link to="/privacidad" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-474">
              Política de privacidad
            </Link>
            <Link to="/reembolsos" className="text-gray-400 hover:text-gold-light transition-colors" data-id="element-475">
              Política de reembolsos
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center text-gray-500 text-sm" data-id="element-476">
          © 2026 LOS 12. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}